var actions, initialState;

actions = require('../actions/games');

initialState = {
  isFetching: false,
  didInvalidate: false,
  items: []
};

module.exports = function(state, action) {
  if (state == null) {
    state = initialState;
  }
  switch (action.type) {
    case actions.INVALIDATE_GAMES:
      return Object.assign({}, state, {
        didInvalidate: true
      });
    case actions.REQUEST_GAMES:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    case actions.RECEIVE_GAMES:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.games,
        lastUpdated: action.receivedAt
      });
    case actions.CREATE_NEW_GAME:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    case actions.DESTROY_GAME:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    case actions.JOIN_GAME:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    case actions.GET_READY:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    case actions.START_GAME:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    case actions.LEAVE_GAME:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    case actions.PICK_CARD:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    case actions.PICK_WINNER:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    default:
      return state;
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/reducers/games.coffee
 ** module id = 282
 ** module chunks = 0
 **/